<div class="wrapper">
  <div class="cuerpo">
    <div class="documento">
      @if (document == undefined) {
      <app-spinner></app-spinner>
      } @else {
      <div>
        <h1 class="tp-navandu line-navandu">Documento {{ document.uuid }}</h1>
        <div class="box">
          <div class="group">
            <span class="label">
              Uuid plantilla:
            </span>
            <span class="data">
              {{ document.templateUuid }}
            </span>
          </div>
          <div class="group">
            <span class="label">
              Nombre plantilla:
            </span>
            <span class="data">
              {{ document.templateName }}
            </span>
          </div>
          <div class="group">
            <span class="label">
              Estado:
            </span>
            <span class="data {{document.status.name}}">
              {{ document.status.nameEs }}
            </span>
          </div>
          @if (document.status.id == 6) {
          <div class="group">
            <span class="label">
              Mensaje de error:
            </span>
            <span class="data {{document.status.name}}">
              {{ document.status.message | errormessage }}
            </span>
          </div>
          }
          @if (document.status.id == 3 && document.rejectReason) {
          <div class="group">
            <span class="label">
              Motivo de rechazo:
            </span>
            @if (flagString) {
            <span class="data">
              {{ document.rejectReason[0].reason }}
            </span>
            } @else {
            <span class="data">{{ document.rejectReason }}</span>
            }
          </div>
          }
          <div class="group">
            <span class="label">
              Fecha creación:
            </span>
            <span class="data">
              {{ document.creationDate }}
            </span>
          </div>
          <div class="group">
            <span class="label">
              Fecha firma:
            </span>
            <span class="data">
              {{ document.signatureDate }}
            </span>
          </div>
          <div class="group">
            <span class="label">
              Tipo de documento:
            </span>
            <span class="data">
              {{ document.documentType }}
            </span>
          </div>
          <div class="group">
            <span class="label">
              Nombre de fichero:
            </span>
            <span class="data">
              {{ document.filename }}
            </span>
          </div>
          <div class="group">
            <span class="label">
              Expediente:
            </span>
            <span class="data">
              {{ document.expedient }}
            </span>
          </div>
        </div>
        @for (signer of document.signers; track signer) {
        <div class="box">
          <h3>Firmante {{ signer.name }} {{ signer.lastName }}</h3>
          <div class="group">
            <span class="label">
              Estado:
            </span>
            @if (signer.state) {
            <span class="data {{signer.state.name}}">
              {{ signer.state.nameEs }}
            </span>
            }
          </div>
          <div class="group">
            <span class="label">
              Identificador:
            </span>
            <span class="data">
              {{ signer.idn }}
            </span>
          </div>
          <div class="group">
            <span class="label">
              Email:
            </span>
            <span class="data">
              {{ signer.email }}
            </span>
          </div>
          <div class="group">
            <span class="label">
              Móvil:
            </span>
            <span class="data">
              {{ signer.phone }}
            </span>
          </div>
          <div class="group">
            <span class="label">
              Dispositivo:
            </span>
            <span class="data">
              {{ signer.device }}
            </span>
          </div>
        </div>
        }
        @if (document.signers[0].vidForms.length > 0) {
        <div class="box">
          <h3>Formularios</h3>
          @for (form of document.signers[0].vidForms; track form) {
          <div>
            <div class="group">
              <span class="label">{{ form.title }}</span>
              <span clas="data">{{ form.response }}</span>
            </div>
          </div>
          }
        </div>
        }
        @if (document.signers[0].forms.length > 0) {
        <div class="box">
          <h3>Formularios</h3>
          @for (form of document.signers[0].forms; track form) {
          <div>
            <div class="group">
              <span class="label">{{ form.text }}</span>
              <span clas="data">{{ form.value }}</span>
            </div>
          </div>
          }
        </div>
        }
        @if (document.variableResponses.length > 0) {
        <div class="box">
          <h3>Variables</h3>
          @for (variable of document.variableResponses; track variable) {
          <div>
            <div class="group">
              <span class="label">{{ variable.name }}</span>
              <span clas="data">{{ variable.value }}</span>
            </div>
          </div>
          }
        </div>
        }
      </div>
      }
    </div>

    @if (backLink != undefined) {
    <a routerLink="{{backLink}}" class="volver">
      <span>Volver</span>
    </a>
    }
  </div>
</div>